import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "",
  description:
    "In this graph the spectrum of a person’s speech under two circumstances is compared. In one instance the subject was asked to read the text without being subject to noise (blue line). Later, the same subject was asked to read the same text, but while being subjected to restaurant noise. The resulting spectrum is plotted as the orange line. ",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/02/18/principle/graph.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
